import React from 'react';

export function CountdownTimer (props) {

    if (isNaN(props.secondsToClose))
        return <></>

    const days = Math.floor(props.secondsToClose / (60 * 60 * 24));
    const hours = Math.floor((props.secondsToClose - (days * 24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((props.secondsToClose - (days * 24 * 60 * 60) - (hours * 60 * 60)) / (60));
    const seconds = props.secondsToClose - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

    return props.secondsToClose <= -2 ?
        <div class="col text-center counter"><span>Lot Closed</span></div>
        : props.secondsToClose <= 0 ?
            <div class="col text-center counter"><span>Closing</span></div>
            :

            <div class="col text-center counter">
                {days > 0 && <span>{days}d </span> }
                {(days > 0 || hours > 0) && <span>{hours}h </span> }
                {(days > 0 || hours > 0 || minutes > 0) && <span>{minutes}m </span> }
                {days == 0 && <span>{seconds}s</span>}
            </div>
}
